import {Injectable} from '@angular/core';
import {Agent} from '../classes/agent';

@Injectable()
export abstract class ChatService {

  // the css is only loaded once
  public abstract initialize(): void;

  public abstract setAgent(agent: Agent, latitude?: number, longitude?: number): void;

  // this means the css has been loaded
  public abstract isInitialized(): boolean;

  /**
   * every page load we need to remove the object from the dom and re-add it with the new agent ID
   * the current implementation of ask avenue widget doesn't allow us to just update the agent id
   */
  public abstract removeWidget(): void;
}
